export const PATIENT_FORM_VERSIONS = {
  // current version
  stable: '2.5',
  // created under "jump-logic-v2" rollout flag
  next: '3.0',
};

export const PATIENT_FORM_VERSION_REDESIGN_POSTFIX = '-redesign';

export const INDICATOR_FIELDS = [
  'emergencyContactFirstName',
  'emergencyContactMiddleName',
  'emergencyContactLastName',
  'emergencyContactAddress1',
  'emergencyContactAddress2',
  'emergencyContactDateOfBirth',
  'emergencyContactNumber',
  'emergencyContactCellPhone',
  'emergencyContactRelationship',
];
